// extracted by mini-css-extract-plugin
export default {"termsModal":"TermsModal_termsModal__IH1aa","closeBtn":"TermsModal_closeBtn__BJtpD","scaleIn":"TermsModal_scaleIn__H0KSC"};